import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 30.586 30.586",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M25.869 25.848a15.738 15.738 0 0 0-21.065-.253l-1.322-1.5a17.738 17.738 0 0 1 23.741.28Z" }, null, -1),
    _createElementVNode("path", { d: "M15.195 8.755a4.96 4.96 0 1 1-4.96 4.96 4.966 4.966 0 0 1 4.96-4.96m0-2a6.96 6.96 0 1 0 6.96 6.96 6.96 6.96 0 0 0-6.96-6.96Z" }, null, -1),
    _createElementVNode("path", { d: "M15.293 2.003A13.293 13.293 0 1 1 2 15.296 13.308 13.308 0 0 1 15.293 2.003m0-2a15.293 15.293 0 1 0 15.293 15.293A15.293 15.293 0 0 0 15.293.003Z" }, null, -1)
  ]))]))
}
export default { render };